// /employee/login/confirm?token=<magic> — Path B step 2.
//
// Consumes the magic-link token, stores the employee JWT in memory,
// and routes to the customer picker.

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { extractApiError } from '../api/client.js';
import * as imp from '../api/impersonation.js';

export function EmployeeLoginConfirm(): JSX.Element {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) return;
    const token = search.get('token');
    if (!token) {
      setErrorMessage('Missing sign-in token.');
      return;
    }
    consumed.current = true;
    void (async () => {
      try {
        await imp.confirmEmployeeLogin(token);
        navigate('/employee/customers', { replace: true });
      } catch (err) {
        setErrorMessage(
          extractApiError(err)?.message ?? 'Sign-in link is invalid or expired.'
        );
      }
    })();
  }, [search, navigate]);

  if (errorMessage) {
    return (
      <div className="card">
        <h2>Sign-in failed</h2>
        <p className="banner banner--error">{errorMessage}</p>
        <p>
          Request a fresh link from the <a href="/employee/login">sign-in page</a>.
        </p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2>Signing you in…</h2>
    </div>
  );
}
